import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { Layout } from 'components/app/Layout';

import { AccountRoutes } from './routes/AccountRoutes';
import { LegalRoutes } from './routes/LegalRoutes';
import { ManagementRoutes } from './routes/ManagementRoutes';
import { OplRoutes } from './routes/OplRoutes';
import { RootRoutes } from './routes/RootRoutes';
import { ServiceCenterRoutes } from './routes/ServiceCenterRoutes';
import { StudioRoutes } from './routes/StudioRoutes';
import { TovertafelRegistrationRoutes } from './routes/TovertafelRegistrationRoutes';
import { Fallback } from './Fallback';

// Articles and categories (and the markdown parser behind them) are not part of the first load.
const ContentPage = lazy(() => import('pages/mytover/ContentPage'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      ...RootRoutes,
      ...AccountRoutes,
      ...ServiceCenterRoutes,
      ...ManagementRoutes,
      ...TovertafelRegistrationRoutes,
      ...StudioRoutes,
      ...LegalRoutes,
      ...OplRoutes,
      {
        path: '*',
        element: (
          <Suspense fallback={<Fallback />}>
            <ContentPage />
          </Suspense>
        ),
      },
    ],
  },
]);
